import { FC } from 'react';
import { Container, Typography } from '@mui/material';

export const HomePage: FC = () => {
  return (
    <Container>
      <Typography variant="h1">Главная</Typography>
    </Container>
  );
};
